import { Component, OnInit } from '@angular/core';
import {NewsService} from "../../services/news.service";
import { ActivatedRoute } from "@angular/router";
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-noticiasmo',
  templateUrl: './noticiasmo.component.html',
  styleUrls: ['./noticiasmo.component.css']
})
export class NoticiasmoComponent implements OnInit {

  noticias: any = [];
  noticia: any = [{ imagen: '', titulo: '', texto: ''}];
  documentos: any = [];
  domain: string;
  url:string;
  constructor(private route: ActivatedRoute, private news: NewsService, private titleService: Title, private metaService: Meta) {
    this.route.params.subscribe( params => {
      this.getNew(params.id);
    });

  }

  ngOnInit() {
    console.log("222222222222222");  
    this.news.getNews().subscribe(response => {
        //this.noticias= response[0];
        this.documentos = response[1];
        console.log('=>', this.documentos);
        /*this.documentos.forEach((item, index) => {
          this.dg1.push({id:item.id,titulo:item.titulo,imagen:item.imagen});
        });*/
        console.log('DOCS', this.documentos);
      
        console.log("popopo", this.noticia);
      },
      error => {
        console.log(<any>error);
      });
    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
        
  }
  private getNew(id){
    this.news.getNew(id).subscribe(response => {


      this.noticia=response[0];
      this.noticias=response[1];
      console.log('NOTICIA',this.noticia);
      this.url = 'libraries/pdf.php?noticia=' + btoa(id) + '&related=PLANIFICACION';      
        //this.test();

    },
    error => {
      console.log(<any>error);
    });
    
      
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/noticiasmo/noticiasmo.component.ts